// 3rd Party
import _ from 'lodash';
import moment from 'moment';
import { Select } from 'opencare-crown';
import PropTypes from 'prop-types';
import React from 'react';

// Components
import {
  Div,
  InputLabel,
  StyledSelect,
} from 'common/styles/oc-styled-components';

import {
  StyledSelectContainer,
  StyledSpan,
} from '../../../checkout-styled-components';

const months = [
  { name: 'January', days: 31 },
  { name: 'February', days: 29 },
  { name: 'March', days: 31 },
  { name: 'April', days: 30 },
  { name: 'May', days: 31 },
  { name: 'June', days: 30 },
  { name: 'July', days: 31 },
  { name: 'August', days: 31 },
  { name: 'September', days: 30 },
  { name: 'October', days: 31 },
  { name: 'November', days: 30 },
  { name: 'December', days: 31 },
];

const monthOptions = months.map((month, i) => (
  <Select.Option key={month.name} value={i + 1}>
    {month.name}
  </Select.Option>
));

const dayOptions = month => {
  const { days } = months[month - 1];

  const daysPerMonth = [];
  _.times(days, i => {
    daysPerMonth.push(
      <Select.Option key={i + 1} value={i + 1}>
        {i + 1}
      </Select.Option>,
    );
  });

  return daysPerMonth;
};

const yearOptions = () => {
  const years = [];
  const min = moment().format('YYYY') - 110;
  const max = moment().format('YYYY');

  for (let i = min; i <= max; i += 1) {
    years.push(
      <Select.Option key={i} value={i}>
        {i}
      </Select.Option>,
    );
  }
  return years.reverse();
};

// Component
export const BirthDateFormRow = ({
  prefix,
  day,
  month,
  year,
  onChange,
  required,
  requiredMessage,
}) => (
  <div>
    <StyledSelectContainer
      itemcount={3}
      data-testid={`${prefix}birthMonth`}
      name={`${prefix}birthMonth`}
      initialValue={month}
      rules={[{ required, message: requiredMessage }]}
      validateTrigger="onSubmit"
    >
      <Div position="relative">
        <StyledSelect
          className="sensitive-data"
          placeholder="--"
          size="large"
          onChange={value => onChange('month', value)}
          value={month}
          aria-label="Birth Month"
        >
          {monthOptions}
        </StyledSelect>
        <InputLabel>Birth Month</InputLabel>
      </Div>
    </StyledSelectContainer>
    <StyledSpan />
    <StyledSelectContainer
      itemcount={3}
      data-testid={`${prefix}birthDay`}
      name={`${prefix}birthDay`}
      initialValue={day}
      rules={[{ required, message: requiredMessage }]}
      validateTrigger="onSubmit"
      disabled={!month}
    >
      <Div position="relative">
        <StyledSelect
          className="sensitive-data"
          placeholder="--"
          size="large"
          disabled={!month}
          onChange={value => onChange('day', value)}
          value={day}
          aria-label="Birth Day"
        >
          {month > 0 && dayOptions(month)}
        </StyledSelect>
        <InputLabel>Birth Day</InputLabel>
      </Div>
    </StyledSelectContainer>
    <StyledSpan />
    <StyledSelectContainer
      itemcount={3}
      data-testid={`${prefix}birthYear`}
      name={`${prefix}birthYear`}
      initialValue={year}
      rules={[{ required, message: requiredMessage }]}
      validateTrigger="onSubmit"
    >
      <Div position="relative">
        <StyledSelect
          className="sensitive-data"
          placeholder="--"
          size="large"
          onChange={value => onChange('year', value)}
          value={year}
          aria-label="Birth Year"
        >
          {yearOptions()}
        </StyledSelect>
        <InputLabel>Birth Year</InputLabel>
      </Div>
    </StyledSelectContainer>
  </div>
);

BirthDateFormRow.defaultProps = {
  prefix: '',
  required: true,
  requiredMessage: 'Required',
};

BirthDateFormRow.propTypes = {
  prefix: PropTypes.string,
  day: PropTypes.number,
  month: PropTypes.number,
  year: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  requiredMessage: PropTypes.string,
};
